<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="hasPerm('chart_of_accounts.create')"
                                @invoke-method="invokeMethod($event)"
                                action="openChartOfAccountForm"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetChartOfAccounts(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>

                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="$t('lang.active_only')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <template>
                        <v-data-table
                            :headers="headers"
                            :items="chart_of_accounts"
                            item-key="account_id"
                            :no-data-text="$t('lang.no_results_matching')"
                            hide-actions
                        >
                            <template slot="items" slot-scope="props">
                                <!-- <tr class="clickable" @mouseup.left="openChartOfAccountForm(props.item)"> -->

                                <tr>
                                    <td>
                                        <bc-tooltip top>
                                            <template slot="activator">
                                                <v-btn icon class="clickable" @mouseup.left="showChildRow(props.item.account_code)">
                                                    <v-icon :ref="`${props.item.account_code}_chevron`"> expand_less </v-icon>
                                                </v-btn>
                                            </template>
                                            Show Sub Accounts
                                        </bc-tooltip>
                                    </td>
                                    <td class="clickable" @mouseup.left="openChartOfAccountForm(props.item)">{{ props.item.account_code }}</td>
                                    <td class="clickable" @mouseup.left="openChartOfAccountForm(props.item)">{{ props.item.account_name }}</td>
                                    <td class="clickable" @mouseup.left="openChartOfAccountForm(props.item)">{{ props.item.account_type }}</td>
                                    <td class="clickable" @mouseup.left="openChartOfAccountForm(props.item)">
                                        <v-chip round text-color="white" class="mr-auto fs-14" :color="props.item.status_class">
                                            <span class="white--text">{{ props.item.is_active == "1" ? $t("lang.active") : $t("lang.disabled") }}</span>
                                        </v-chip>
                                    </td>
                                </tr>
                                <tr v-for="(sub, index) in sub_accounts" :ref="props.item.account_code" style="display: none">
                                    <td>
                                        <div v-if="index != sub_accounts.length - 1" style="width: 2px; background: black; height: 100%; margin: auto"></div>
                                        <div
                                            v-else
                                            style="
                                                width: 12px;
                                                border-left: 2px solid black;
                                                border-bottom: 2px solid black;
                                                height: 50%;
                                                position: relative;
                                                top: -15px;
                                                margin: auto;
                                                left: 5px;
                                            "
                                        ></div>
                                    </td>
                                    <td class="clickable" @mouseup.left="openChartOfAccountForm(sub)">{{ sub.account_code }}</td>
                                    <td class="clickable" @mouseup.left="openChartOfAccountForm(sub)">{{ sub.account_name }}</td>
                                    <td class="clickable" @mouseup.left="openChartOfAccountForm(sub)">{{ sub.account_type }}</td>
                                    <td class="clickable" @mouseup.left="openChartOfAccountForm(sub)">
                                        <v-chip round text-color="white" class="mr-auto fs-14" color="green">
                                            <span class="white--text">{{ sub.is_active == "1" ? $t("lang.active") : $t("lang.disabled") }}</span>
                                        </v-chip>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>

                    <bc-pagination :page="page" :params="axiosParams" name="chart_of_accounts"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="chart_of_account_dialog">
                <v-card>
                    <v-form ref="form_chart_of_account">
                        <v-card-title>
                            <span class="headline">{{ chart_of_account.account_id ? $t("lang.edit_chart_of_account") : $t("lang.add_chart_of_account") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeChartOfAccountDialog"
                                :dialog-status="chart_of_account_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="chart_of_account_dialog"
                                            v-model="chart_of_account.account_id"
                                            :label="`${$t('lang.account_id')} *`"
                                            :counter="showCounter(chart_of_account.account_id, 'chart_of_accounts.account_id')"
                                            :rules="ifValid('chart_of_accounts.account_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="chart_of_account.account_code"
                                            :label="`${$t('lang.account_code')} *`"
                                            :counter="showCounter(chart_of_account.account_code, 'chart_of_accounts.account_code')"
                                            :rules="ifValid('chart_of_accounts.account_code')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="chart_of_account.account_name"
                                            :label="`${$t('lang.account_name')} *`"
                                            :counter="showCounter(chart_of_account.account_name, 'chart_of_accounts.account_name')"
                                            :rules="ifValid('chart_of_accounts.account_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="chart_of_account.account_type"
                                            :label="`${$t('lang.account_type')} *`"
                                            :counter="showCounter(chart_of_account.account_type, 'chart_of_accounts.account_type')"
                                            :rules="ifValid('chart_of_accounts.account_type')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-select
                                            v-model="chart_of_account.is_active"
                                            :label="`${$t('lang.is_active')} *`"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('chart_of_accounts.is_active')"
                                        ></bc-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="chart_of_account.account_id" color="error" @mouseup.left="$refs.delete_chart_of_accounts.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeChartOfAccountDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveChartOfAccounts">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_chart_of_accounts"
                :heading="$t('lang.delete_chart_of_account')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteChartOfAccounts(chart_of_account.account_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openChartOfAccountForm" },
                { title: this.$t("lang.refresh"), action: "dbGetChartOfAccounts", params: [true] },
            ],
            headers: [
                { text: "", sortable: false, width: "1%" },
                { text: this.$t("lang.account_code"), sortable: false, width: "20%" },
                { text: this.$t("lang.account_name"), sortable: false, width: "20%" },
                { text: this.$t("lang.account_type"), sortable: false, width: "20%" },
                { text: this.$t("lang.is_active"), sortable: false, width: "20%" },
            ],
            enableAddModal: true,
            enableEditModal: true,

            chart_of_account: {},
            filter: {
                search: "",
                status: "1",
            },
            chart_of_account_dialog: false,
            dbGetChartOfAccounts: _.debounce(this.getChartOfAccounts, 1500, { maxWait: 1500, leading: true, trailing: false }),
            expand: false,
            sub_accounts: [
                { account_code: 2001, account_name: "Expense Account", account_type: "liability", is_active: "1" },
                { account_code: 2002, account_name: "Expense Account", account_type: "liability", is_active: "1" },
                { account_code: 2003, account_name: "Expense Account", account_type: "liability", is_active: "1" },
                { account_code: 2004, account_name: "Expense Account", account_type: "liability", is_active: "1" },
            ],
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchChartOfAccounts", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.chart_of_accounts) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchChartOfAccounts({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.chart_of_accounts) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.chart_of_accounts.chart_of_accounts_filter,
            page: (state) => state.chart_of_accounts.page,
            rules_chart_of_accounts: (state) => state.chart_of_accounts.rules_chart_of_accounts,
            chart_of_account_status_options: (state) => state.settings.chart_of_account_status_options,
            chart_of_accounts: (state) => state.chart_of_accounts.chart_of_accounts,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchChartOfAccounts", "saveChartOfAccount", "deleteChartOfAccount"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openChartOfAccountForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.customers == null) this.getCustomers();
                    if (this.$refs.form_chart_of_account) item ? this.$refs.form_chart_of_account.resetValidation() : this.$refs.form_chart_of_account.reset();

                    this.$nextTick(() => {
                        this.chart_of_account = item != null ? this.assignObj2(item, this.rules_chart_of_accounts) : {};
                        this.chart_of_account_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "chart_of_account", params: { id: item.account_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.customers == null) this.getCustomers();
                    if (this.$refs.form_chart_of_account) item ? this.$refs.form_chart_of_account.resetValidation() : this.$refs.form_chart_of_account.reset();
                    this.chart_of_account_dialog = true;
                } else {
                    this.$router.push({ name: "chart_of_account" });
                }
            }
        },
        saveChartOfAccounts() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_chart_of_account")) {
                    let body = this.prepForm(this.chart_of_account, this.rules_chart_of_accounts);

                    this.saveChartOfAccount({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getChartOfAccounts();
                                this.closeChartOfAccountDialog();
                            } else {
                                this.$router.push({ name: "chart_of_account", params: { id: data.account_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteChartOfAccounts(id = null) {
            this.deleteChartOfAccount({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getChartOfAccounts();
                    this.closeChartOfAccountDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeChartOfAccountDialog() {
            this.chart_of_account_dialog = false;
            this.$refs.delete_chart_of_accounts.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getChartOfAccounts(pg_refresh = false) {
            this.startLoader();

            this.fetchChartOfAccounts({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.chart_of_account_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        showChildRow(account_code) {
            let chevron = account_code + "_chevron";
            const style = window.getComputedStyle(this.$refs[chevron].$el);
            const transform = style.getPropertyValue("transform");

            if (transform == "none" || transform == "matrix(1, 0, 0, 1, 0, 0)") {
                this.$refs[chevron].$el.style.transform = "rotate(180deg)";
            } else {
                this.$refs[chevron].$el.style.transform = "rotate(0deg)";
            }

            if (typeof this.$refs[account_code] == "object") {
                for (let i in this.$refs[account_code]) {
                    if (this.$refs[account_code][i].style.display == "table-row") {
                        this.$refs[account_code][i].style.display = "none";
                    } else {
                        this.$refs[account_code][i].style.display = "table-row";
                    }
                }
            } else {
                if (this.$refs[account_code].style.display == "table-row") {
                    this.$refs[account_code].style.display = "none";
                } else {
                    this.$refs[account_code].style.display = "table-row";
                }
            }
        },
    },
};
</script>
<style>
.rotate-90 {
    transform: rotate(90deg);
}
</style>
